const DIRECTIONS = [
  [0, 1], [0, -1], [1, 0], [-1, 0],
  [1, 1], [1, -1], [-1, 1], [-1, -1],
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/** Builds an NxN letter grid with every word in `words` hidden in a straight line (any of 8 directions), remaining cells randomized — a from-scratch equivalent of the old jQuery word-search widget's grid generator. */
export function buildWordSearchGrid(words, size) {
  const grid = Array.from({ length: size }, () => Array(size).fill(null));

  const fits = (word, row, col, dr, dc) => {
    const endRow = row + dr * (word.length - 1);
    const endCol = col + dc * (word.length - 1);
    if (endRow < 0 || endRow >= size || endCol < 0 || endCol >= size) return false;
    for (let i = 0; i < word.length; i++) {
      const r = row + dr * i;
      const c = col + dc * i;
      const existing = grid[r][c];
      if (existing != null && existing !== word[i]) return false;
    }
    return true;
  };

  const place = (word, row, col, dr, dc) => {
    for (let i = 0; i < word.length; i++) {
      grid[row + dr * i][col + dc * i] = word[i];
    }
  };

  for (const word of words) {
    let placed = false;
    for (let attempt = 0; attempt < 400 && !placed; attempt++) {
      const [dr, dc] = DIRECTIONS[Math.floor(Math.random() * DIRECTIONS.length)];
      const row = Math.floor(Math.random() * size);
      const col = Math.floor(Math.random() * size);
      if (fits(word, row, col, dr, dc)) {
        place(word, row, col, dr, dc);
        placed = true;
      }
    }
    if (!placed) {
      // Fallback: force it horizontally on the first row that fits, growing the search until one works.
      for (let row = 0; row < size && !placed; row++) {
        if (fits(word, row, 0, 0, 1)) {
          place(word, row, 0, 0, 1);
          placed = true;
        }
      }
    }
  }

  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      if (grid[r][c] == null) {
        grid[r][c] = LETTERS[Math.floor(Math.random() * LETTERS.length)];
      }
    }
  }

  return grid;
}

/** Returns the cell path between two grid coordinates if it's a straight horizontal/vertical/diagonal line, else null. */
export function straightLinePath(r0, c0, r1, c1) {
  const dr = r1 - r0;
  const dc = c1 - c0;
  if (dr !== 0 && dc !== 0 && Math.abs(dr) !== Math.abs(dc)) return null;
  const steps = Math.max(Math.abs(dr), Math.abs(dc));
  const sr = dr === 0 ? 0 : dr / Math.abs(dr);
  const sc = dc === 0 ? 0 : dc / Math.abs(dc);
  const path = [];
  for (let i = 0; i <= steps; i++) {
    path.push([r0 + sr * i, c0 + sc * i]);
  }
  return path;
}
